module.exports = __webpack_public_path__ + "static/img/erweima2.fa9ae79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/erweima2.jpg
// module id = 0p5f
// module chunks = 2